/* ============================================================================================== */
/* ============================== Custom Article Table of Contents ============================== */
/* ============================================================================================== */

// returns a numerical value for each heading
const headingLevel = (heading: Node) => {
    return ['H1', 'H2', 'H3', 'H4', 'H5', 'H6'].indexOf(heading.nodeName) + 1;
};

// inserts a new line to the current list
const newLi = (heading: HTMLHeadElement, list: HTMLUListElement) => {
    if (heading.textContent?.replace(/\s/g, '') === '') {
        return null;
    }
    const wrapper = document.createElement('li');
    const anchorName = heading.textContent?.replace(/\s/g, '');
    const link = document.createElement('a');
    link.href = `#${anchorName}`;
    link.innerHTML = heading.textContent || '';
    wrapper.appendChild(link);
    list.appendChild(wrapper);
    const linkText = link.querySelector('.index')?.textContent || '';
    heading.innerHTML = `<a name="${anchorName}"></a>${linkText} ${heading.textContent}`;
};

// adds a new UL to the current UL
const nestUl = (currentUl: HTMLElement) => {
    const newUl = document.createElement('ul');
    currentUl.appendChild(newUl);
    return newUl;
};

const insertHeading = (
    firstUl: HTMLUListElement,
    heading: HTMLElement,
    previousLevel: number,
    currentUl: HTMLUListElement,
    arrayUl: HTMLUListElement[],
) => {
    // what level heading are we on?
    const currentLevel = headingLevel(heading);

    // if it's an H1, add it to the original list
    if (currentLevel === 1) {
        newLi(heading, firstUl);
        currentUl = firstUl;
        arrayUl = [];
        arrayUl.push(firstUl);
    }

    // if it's the same as the one before it, add it to the current list
    else if (currentLevel === previousLevel) {
        newLi(heading, currentUl);
    }

    // if it's one level higher than the one before it... time to make a new nested list
    else if (currentLevel > previousLevel) {
        currentUl = nestUl(currentUl);
        arrayUl.push(currentUl);
        newLi(heading, currentUl);
    } else if (currentLevel < previousLevel) {
        for (let i = 0; i < previousLevel - currentLevel; i++) {
            arrayUl.pop();
        }
        currentUl = arrayUl[arrayUl.length - 1];
        newLi(heading, currentUl);
    }

    let nextHeading;
    let sibling = heading.nextElementSibling;
    while (sibling) {
        if (['h1', 'h2', 'h3', 'h4', 'h5', 'h6'].includes(sibling.tagName)) {
            nextHeading = sibling;
            break;
        }
        sibling = sibling.nextElementSibling;
    }

    if (nextHeading instanceof HTMLElement) {
        insertHeading(firstUl, nextHeading, currentLevel, currentUl, arrayUl);
    }
};

export const articlePage = () => {
    const firstUl = document.createElement('ul');
    let headersFirstH1 = document.querySelector<HTMLHeadingElement>('.article-body h1');

    if (!headersFirstH1) {
        headersFirstH1 = document.querySelector<HTMLHeadingElement>('.article-body h2');
    }

    if (headersFirstH1) {
        const toc = document.createElement('div');
        toc.className = 'toc';
        toc.style.marginBottom = '25px';

        toc?.appendChild(firstUl);
        const tableOfContents = document.querySelector('#table-of-contents');
        const articleBody = document.querySelector('.article-body');

        if (tableOfContents && toc) {
            tableOfContents.appendChild(toc);
        } else if (articleBody && toc) {
            articleBody.prepend(toc);
        }

        // start with first H1
        insertHeading(firstUl, headersFirstH1, 1, firstUl, []);
    }
};

export default articlePage;
